import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { YoutubeVideoInterface, setEditId, setEditError, selectYoutubeVideoById } from "../../../store/mine_craft/youtubeVideosSlice";
import { updateYoutubeVideo, fetchYoutubeVideo } from "../../../actions/mine_craft/youtubeVideosActions";
import { objToFormData } from "../../../helpers/FormHelper";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const Edit = () => {
  const dispatch      = useAppDispatch();
  const location      = useLocation();
  const id: any       = useAppSelector(state => state.mineCraft.youtubeVideos.editId);
  const error         = useAppSelector(state => state.mineCraft.youtubeVideos.editError);
  const youtubeVideo = useAppSelector(state => id ? selectYoutubeVideoById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchYoutubeVideo(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(setEditId(null));
  }, [location, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: YoutubeVideoInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: YoutubeVideoInterface) {
    const formData: any = objToFormData(data);
    const resultAction = await dispatch(updateYoutubeVideo({ id, data: formData }));

    if (updateYoutubeVideo.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-youtubeVideo'>
        <h6 className="v-content-label">Edit YoutubeVideo</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={youtubeVideo} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
